module.exports = __webpack_public_path__ + "static/media/vg.9663fd55.svg";